import graphql__94bdf5cf093f5be4ffa3 from "./__generated__/ContributionsGrid_participativeModule.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ContributionsGridTiles, {
  ContributionsGridTiles_participativeModule
} from "./ContributionsGridTiles";
import { ResourcesListProvider } from "../../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../../ResourcesList/ResourcesListUrlSearchSync";
import { useFormatMessage } from "../../Intl/Context";
import { getContributionsAnchorId } from "../../Utils/anchorIds";
import AnchorTarget from "../../Utils/AnchorTarget";
import ContributionsListFilters from "./ContributionsListFilters";
import Icon from "../../Utils/Icon";
import { BoxSpinner } from "../../Utils/Spinner";
import ModalOutlet from "../../Routing/ModalOutlet";

export const CONTRIBUTIONS_BATCH_SIZE = 12;

const ContributionsGrid = props => {
  const participativeModule = useFragment(
    ContributionsGrid_participativeModule,
    props.participativeModule
  );

  const t = useFormatMessage();
  const listTitle = t(intlMessages.listTitle);
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <ResourcesListProvider>
      <ResourcesListUrlSearchSync />
      <div className="container participative-module-container">
        <div className="contributions-list">
          <AnchorTarget id={contributionsAnchorId} />

          <div className="box margin-bottom-xs">
            <div className="contributions-list-title height-lg padding-y-md padding-x-sm text-title-section with-icon">
              <Icon className="text-primary icon-debate" />
              <h2 className="with-icon-text text-subtitle-page font-weight-bold">
                {listTitle}
              </h2>
            </div>
          </div>

          <ContributionsListFilters
            participativeModule={participativeModule}
            refetchFragment={ContributionsGridTiles_participativeModule}
            collapsible={false}
          />

          <Suspense fallback={<BoxSpinner />}>
            <ContributionsGridTiles participativeModule={participativeModule} />
          </Suspense>
        </div>
      </div>

      <ModalOutlet />
    </ResourcesListProvider>
  );
};

const ContributionsGrid_participativeModule = graphql__94bdf5cf093f5be4ffa3;

export default ContributionsGrid;

const intlMessages = defineMessages({
  listTitle: {
    id: "participativeModule.contributionsList.listTitle",
    defaultMessage: "Les contributions"
  }
});
